module.exports = __webpack_public_path__ + "media/images/lb/303-903dd3696fcd48239f938958ab712c81.svg";